/**
 * Merge server-side shared-account totals with the identity owned by this
 * browser. Server refreshes must never replace one diner's identity with the
 * first diner's billing contact.
 */
export function mergeTableSessionWithDeviceIdentity(serverSession, deviceSession) {
  const hasDeviceIdentity = deviceSession?.identity_scope === "device";
  const deviceName = hasDeviceIdentity && typeof deviceSession?.customer_name === "string"
    ? deviceSession.customer_name
    : "";
  const devicePhone = hasDeviceIdentity && typeof deviceSession?.customer_phone === "string"
    ? deviceSession.customer_phone
    : "";

  return {
    ...(serverSession || {}),
    identity_scope: hasDeviceIdentity ? "device" : undefined,
    customer_name: deviceName,
    customer_phone: devicePhone,
  };
}
